// One place that knows whether the total on screen can still change under the buyer.
//
// Two things make it unsafe to take payment. A VIES lookup for the entered VAT number has not
// come back — reverse charge can take the tax to zero, so paying first can mean paying VAT that
// isn't owed. Or a cart update is in flight or queued, which is the same problem in general
// form: the server is still deciding what this costs.
//
// The VAT half is recorded as an attribute on the cart form rather than as state on the Pay
// button, because checkout_update re-renders #cart-payment on every cart update: anything set
// on the button is thrown away mid-lookup and comes back enabled. The form is never replaced.
// It also keeps us clear of Stripe's js-disabled-for-stripe bookkeeping — we never touch
// button.disabled, so neither side can release the other's lock.
//
// Set and cleared by address_info_component_controller. Read by
// payment_form_component_controller (the ordinary submit, which is also what Enter triggers),
// by express_checkout_component_controller (the wallet path, which never goes through the
// ordinary submit), and by payment_form_component.scss to show the wait notice.
export const VAT_CHECK_PENDING = 'data-vat-check-pending'

export const CART_FORM_SELECTOR = '.cart-checkout-details'

// The cart's own in-flight/queued latches, set by doUpdate and cleared by finishCartUpdate.
// Included here so the release of VAT_CHECK_PENDING can never open a window on its own: the
// idle poll gives up eventually, and without these a submit could land while the update that
// carries the answer is still running.
export const CART_UPDATE_ATTRIBUTES = [
  'data-request-in-progress',
  'data-loading-cart-update',
  'data-pending-cart-update',
]

export const PAYMENT_BLOCKING_ATTRIBUTES = [
  VAT_CHECK_PENDING,
  ...CART_UPDATE_ATTRIBUTES,
]

export function cartForm(root = document) {
  return root.querySelector(CART_FORM_SELECTOR)
}

// True while the amount is still being decided, for either reason. Every payment path must
// refuse while this holds — the ordinary submit, Enter, and the wallets.
export function vatCheckPending(root = document) {
  return PAYMENT_BLOCKING_ATTRIBUTES.some((attribute) =>
    Boolean(root.querySelector(`${CART_FORM_SELECTOR}[${attribute}]`))
  )
}
